<template>
    <div>
        <slot :filterList="filterList" :categories="categories" :filteredPosts="filteredPosts"></slot>
    </div>
</template>

<script>
import { defineComponent, ref, onMounted } from 'vue';
import { uniq, groupBy, flatten } from 'lodash';
import { getPosts } from '../services/inventory';

export default defineComponent({
    name: 'ArticleListHub',
    props: {
        blogId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const categories = ref([]);
        const posts = ref([]);
        const selectedCategory = ref('');
        const filteredPosts = ref([]);

        onMounted(async () => {
            const response = await getPosts(props.blogId);

            posts.value = response;

            const postCategories = response.map(post => {
                return (post?.categories || []).map(category => {
                    return category.title;
                });
            });

            categories.value = uniq(flatten(postCategories));

            processResults();
        });

        const filterList = function (event) {
            selectedCategory.value = event.target.value;

            processResults();
        }

        const processResults = () => {
            filteredPosts.value = posts.value.filter(post => {
                if (!selectedCategory.value) {
                    return true;
                }

                return (post?.categories || []).some(category => {
                    return category.title === selectedCategory.value;
                });
            });
        }

        return {
            filteredPosts: filteredPosts,
            filterList: filterList,
            categories: categories,
        }
    }
});

</script>


